export default __webpack_public_path__ + "assets/facilities-3.79fc8f6a.png";